// eslint-disable-next-line no-useless-escape
const INVALID_FILE_NAME_CHARACTERS_REGEX = /[\/\\:*?"<>|]/g;
const DIACRITICS_REGEX = /[\u0300-\u036f]/g;
const WHITESPACE_SEQUENCE_REGEX = /\s+/g;
const INVALID_UNDERSCORE_SEQUENCE_REGEX = /_+/g;
const INVALID_ASCII_FILE_NAME_CHARACTERS_REGEX = /[^A-Za-z0-9._-]/g;

const sanitizeFileNamePart = (value, { preserveDots = true } = {}) => {
  const invalidCharactersRegex = preserveDots
    ? INVALID_ASCII_FILE_NAME_CHARACTERS_REGEX
    : /[^A-Za-z0-9_-]/g;

  return String(value || '')
    .normalize('NFD')
    .replace(DIACRITICS_REGEX, '')
    .replace(WHITESPACE_SEQUENCE_REGEX, '_')
    .replace(INVALID_FILE_NAME_CHARACTERS_REGEX, '_')
    .replace(invalidCharactersRegex, '_')
    .replace(INVALID_UNDERSCORE_SEQUENCE_REGEX, '_')
    .replace(/^[._\s]+|[._\s]+$/g, '');
};

const sanitizeFileName = fileName => {
  const normalizedFileName = String(fileName || '').trim();
  const lastDotIndex = normalizedFileName.lastIndexOf('.');
  const hasExtension = lastDotIndex >= 0 && lastDotIndex < normalizedFileName.length - 1;
  const baseName = hasExtension ? normalizedFileName.substring(0, lastDotIndex) : normalizedFileName;
  const extension = hasExtension ? normalizedFileName.substring(lastDotIndex + 1) : '';
  const sanitizedBaseName = sanitizeFileNamePart(baseName) || 'arquivo';
  const sanitizedExtension = sanitizeFileNamePart(extension, { preserveDots: false });

  return sanitizedExtension ? `${sanitizedBaseName}.${sanitizedExtension}` : sanitizedBaseName;
};

export default sanitizeFileName;
